import { Navigate } from 'react-router';

import { useAdminAccess } from '@/hooks/useAdminAccess';

const AdminRoute = ({ children }) => {
  const { isAdminOrSuperAdmin } = useAdminAccess();

  if (!isAdminOrSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
